import { render, staticRenderFns } from "./CompanyTableOperations.vue?vue&type=template&id=389a1246"
import script from "./CompanyTableOperations.vue?vue&type=script&lang=ts"
export * from "./CompanyTableOperations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports